import React from 'react';

export default class Footer extends React.Component {


    static propTypes = {
//    activeName : React.PropTypes.string.isRequired,
//    onMenuClick : React.PropTypes.func.isRequired,
//    activeName2 : React.PropTypes.string.isRequired
    };


    constructor(props) {
        super(props);
    }


    componentDidMount() {

    }

    render() {
        return (
            <footer>
                <p>Copyright Coupang Corp.,Ltd. All rights reserved.</p>
            </footer>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/layout/Footer.jsx